import React, { useState } from "react";
import Input from "../controls/Input";
import { useFormik } from "formik";
import * as yup from "yup";
import { HiMenu } from "react-icons/hi";
import { PiPhone } from "react-icons/pi";
import { ForgotPassword, ForgotPasswordInitiate } from "../../configurations/crud/applicationUserCrud";
import LodingButton from "../controls/LodingButton";
import { Link } from "react-router-dom";
import { useToast } from "../controls/Toast/ToastService";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { MdErrorOutline } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { RiLockPasswordLine } from "react-icons/ri";
import { TbPasswordFingerprint } from "react-icons/tb";
import useGlobalLoader from "../../configurations/useGlobalLoader";
import Card from "../controls/Card";
import MasterPage from "../app/MasterPage";

const schema = yup.object().shape({
  UserName: yup
    .string()
    .min(10, "Must be mobile number")
    .max(10, "Must be mobile number")
    .required("Mobile number is required."),
  OTP: yup.string().required("OTP is required."),
  NewPass: yup
    .string()
    .min(8, "Password must have 8 charactors")
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/, {
      message:
        "Password should contains one Capital letter, one small letter, one special charactor and a digit.",
    })
    .required("New password is required."),
  ConfirmPassword: yup
    .string()
    .oneOf(
      [yup.ref("NewPass"), null],
      "New password and Confirm password missmatch"
    )
    .required("Confirm password is required."),
});

export default function ForgetPassword() {
  const { start, end } = useGlobalLoader()
  const [level, setLevel] = useState(1);
  const [loding, setLoding] = useState(false)
  const toast = useToast()

  const {
    values,
    errors,
    isValid,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    setValues,
  } = useFormik({
    initialValues: {
      UserName: "",
      OTP: "",
      NewPass: "",
      ConfirmPassword: "",
    },
    validationSchema: schema,
    onSubmit(values) {
      handleForgetPassword(values)
    }
  });


  function handleForgetPassword(val) {
    setLoding(true)
    start()
    ForgotPassword(values).then(res => {
      if (res.data) {
        let data = res.data
        if (data.succeeded) {
          setLevel(0)
          setValues({ ...values, OTP: "", NewPass: "", ConfirmPassword: "" })
          toast.open("Password has been changed successfully.", <IoCheckmarkDoneCircleOutline />, "success")
        } else {
          if (data.code === 108) {
            setLevel(2)
            toast.open(data.message, <MdErrorOutline />, "danger")
          }
          else {
            toast.open(data.message, <MdErrorOutline />, "danger")
          }
        }
      }
      else {
        toast.open("Server Error", <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const handleInitiateForgrtPassword = () => {
    setLoding(true)
    start()
    if (values.UserName) {
      ForgotPasswordInitiate(values).then(res => {
        if (res.data) {
          let data = res.data
          if (data.result.succeeded) {
            setLevel(2)
            toast.open("Otp sent successfully.", <IoCheckmarkDoneCircleOutline />, "success")
          } else {
            toast.open(data.result.message, <IoCheckmarkDoneCircleOutline />, "success")
          }
        }
        else {
          toast.open("Server Error", <MdErrorOutline />, "danger")
        }
        setLoding(false)
        end()
      }).catch(errors => {
        setLoding(false)
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      })
    }
    else {
      toast.open("Please enter Mobile/ User", <MdErrorOutline />, "danger")
      setLoding(false)
      end()
    }
  }

  return (
    <MasterPage>
      <div className="flex flex-col min-h-full justify-center px-6 py-12 lg:px-8 bg-slate-100">
        <div className="mx-auto w-full max-w-sm p-6 flex flex-col min-h-full justify-center">
          <Card title={"Forget Password"} isBorder={true} isBack={true}>
            <form onSubmit={handleSubmit} autoComplete="off">
              <div className="my-5 sm:mx-auto sm:w-full sm:max-w-sm ">
                <div className="space-y-3">
                  {level === 1 ? (
                    <>
                      <div>
                        <label
                          htmlFor="UserName"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          Mobile no.
                        </label>
                        <div className="mt-2">
                          <Input
                            type="number"
                            placeholder="Enter mobile no."
                            id="UserName"
                            Icon={<FaPhoneAlt className="text-green-600 h-4 w-4" />}
                            value={values.UserName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isError={errors.UserName && touched.UserName}
                          />
                          {errors.UserName && touched.UserName && (
                            <p className="text-red-600 text-xs">
                              {errors.UserName}
                            </p>
                          )}
                        </div>
                      </div>
                      <div>
                        {!loding ?
                          <button
                            className={
                              errors.UserName ? "btn-blue-disabled" : "btn-blue"
                            }
                            disabled={errors.UserName}
                            onClick={handleInitiateForgrtPassword}
                          >
                            Get OTP
                          </button>
                          :
                          <LodingButton text="Sending OTP" />
                        }
                      </div>
                    </>
                  ) : (
                    <>
                      {level === 2 ? (
                        <>
                          <div>
                            <h1 className="text-3xl flex justify-center items-center text-green-600">
                              {" "}
                              <PiPhone /> {values.UserName}
                            </h1>
                          </div>
                          <div>
                            <label
                              htmlFor="OTP"
                              className="block text-sm font-medium leading-6 text-gray-900"
                            >
                              OTP
                            </label>
                            <div className="mt-2">
                              <Input
                                placeholder="Enter OTP"
                                type="password"
                                id="OTP"
                                Icon={<TbPasswordFingerprint className="text-blue-400 h-4 w-4" />}
                                value={values.OTP}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.OTP && touched.OTP}
                              />
                              {errors.OTP && touched.OTP && (
                                <p className="text-red-600 text-xs">
                                  {errors.OTP}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="flex justify-center">
                            <button
                              className="hyper-link flex w-full justify-center cursor-pointer px-3 py-1.5 text-sm"
                              onClick={() => { setLevel(1); setValues({ ...values, OTP: "" }) }}
                            >
                              Back
                            </button>
                            <button
                              className={
                                errors.OTP ? "btn-blue-disabled" : "btn-blue"
                              }
                              disabled={errors.OTP}
                              onClick={() => setLevel(3)}
                            >
                              Varify OTP
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          {level === 3 ? (
                            <>
                              <div>
                                <h1 className="text-3xl flex justify-center items-center text-green-600">
                                  {" "}
                                  <PiPhone /> {values.UserName}
                                </h1>
                              </div>
                              <div>
                                <label
                                  htmlFor="NewPass"
                                  className="block text-sm font-medium leading-6 text-gray-900"
                                >
                                  New Password
                                </label>
                                <div className="mt-2">
                                  <Input
                                    placeholder="Enter new password"
                                    type="password"
                                    id="NewPass"
                                    Icon={<RiLockPasswordLine className="text-green-500 h-4 w-4" />}
                                    value={values.NewPass}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isError={
                                      errors.NewPass && touched.NewPass
                                    }
                                  />
                                  {errors.NewPass && touched.NewPass && (
                                    <p className="text-red-600 text-xs">
                                      {errors.NewPass}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div>
                                <label
                                  htmlFor="ConfirmPassword"
                                  className="block text-sm font-medium leading-6 text-gray-900"
                                >
                                  Confirm Password
                                </label>
                                <div className="mt-2">
                                  <Input
                                    placeholder="Enter confirm password"
                                    type="password"
                                    id="ConfirmPassword"
                                    Icon={<RiLockPasswordLine className="text-green-500 h-4 w-4" />}
                                    value={values.ConfirmPassword}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isError={
                                      errors.ConfirmPassword &&
                                      touched.ConfirmPassword
                                    }
                                  />
                                  {errors.ConfirmPassword &&
                                    touched.ConfirmPassword && (
                                      <p className="text-red-600 text-xs">
                                        {errors.ConfirmPassword}
                                      </p>
                                    )}
                                </div>
                              </div>

                              <div className="flex">
                                <button
                                  className="hyper-link flex w-full justify-center cursor-pointer px-3 py-1.5 text-sm"
                                  onClick={() => { setLevel(2) }}
                                >
                                  Change OTP
                                </button>

                                {!loding ?
                                  <button className={!isValid ? "btn-blue-disabled" : "btn-blue"} disabled={!isValid} type='submit'>
                                    Reset Password
                                  </button>
                                  :
                                  <LodingButton text={"Resetting"} />
                                }
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="flex flex-col">
                                <h1 className="text-3xl flex justify-center items-center text-green-600">
                                  {" "}
                                  <PiPhone /> {values.UserName}
                                </h1>
                                <h1 className="text-2xl">
                                  Password has been updated successfully.
                                </h1>
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </form>
          </Card>
        </div>
      </div>
    </MasterPage>
  );
}
